export {
  deleteFx as deleteIntegrationFx,
  getFx as getIntegrationFx,
  Gate as IntegrationGate,
  $isActive as $isIntegrationActive,
  set as setIntegration,
  $fields as $integrationFields,
  $getStatus as $getIntegrationStatus,
} from './model'
